'use client'

import * as React from 'react'

type CheckboxProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> & {
  label: string
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, id, ...props }, ref) => {
    const reactId = React.useId()
    const fieldId = id ?? `checkbox-${reactId}`
    return (
      <label htmlFor={fieldId}>
        <input ref={ref} id={fieldId} type='checkbox' {...props} /> {label}
      </label>
    )
  }
)

Checkbox.displayName = 'Checkbox'
